<div class="container">
  <div class="row" class="back-row">
    <mat-icon (click)="back()" style="cursor: pointer">arrow_back</mat-icon>
  </div>
  <app-teacher-info [teacher]="teacher"></app-teacher-info>
  <app-teacher-project-list [teacher]="teacher"></app-teacher-project-list>
</div>
